<!--
 * @Author: 曹捷
 * @Date: 2021-11-09 16:49:52
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-11 14:20:09
 * @Description: 主框架面包屑 
-->
<template>
  <a-breadcrumb class="app-breadcrumb" separator="/">
    <a-breadcrumb-item class="bread-item" :key="'bread' + index" v-for="(item, index) in levelList">
      <span class="no-redirect" v-if="item.path === 'noRedirect' || index == levelList.length - 1">{{ item.name }}</span>
      <a @click.prevent="handleLink(item)" v-else>{{ item.name }}</a>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
import { toRefs, watch } from 'vue'
import { reactive } from '@vue/reactivity'
import { useRoute, useRouter } from 'vue-router'
export default {
  props: {},
  setup (props, context) {
    let _data = reactive({
      levelList: []
    })
    let route = useRoute()
    let router = useRouter()
    let methods = {
      initList () {
        let routeList = router.options.routes
        let arr = []
        if (route.path.indexOf('main/set') !== -1) {
          arr.push({
            name: '设置', path: '/main/set/myserver'
          })
        } else {
          arr.push({
            name: '首页', path: '/'
          })
        }
        let item = routeList.find(el => el.path === route.path)
        if (item && item.meta.name) {
          arr.push({
            name: item.meta.name,
            path: item.path,
            meta: item.meta,
          })
        }
        _data.levelList = arr
      },
      handleLink (item) {
        const { path } = item
        if (path) {
          if (path === route.path) {
            return
          }
          router.push(path)
          return
        }
      },
    }
    watch(() => route.path, (value) => {
      methods.initList()
    })
    methods.initList()
    return {
      ...toRefs(_data),
      ...methods
    }
  }
}
</script>

<style>
</style>